import attribs from '../../settings/references.json'
import { launcherOpenUrl } from '../../launcherBackend/launcher-command'
import { actionLoggerLog } from '../../actions'

export { default as getTexts } from '../../store/localizer'

export const attributes = {
    patchNotes: attribs.link.patchNotes,
}

export const commands = {
    launcherOpenUrl,
}

export const actions = {
    log: actionLoggerLog,
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/imports.js